import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["MainSidebar"], {
    "use-slide": $setup.useSlide,
    "compact-mode": $setup.compactMode,
    "fixed-slide": $setup.fixedSlide
  }, null, 8, ["use-slide", "compact-mode", "fixed-slide"]))
}